import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RankmiTable } from '@rankmi/rankmi-table'
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus'
import { faBook } from '@fortawesome/pro-solid-svg-icons/faBook'
import { rolesService } from 'api/configuration/roles'
import { ICourse, IRole } from 'interfaces/roles'
import { Modal } from 'components/reusables/modal'
import { ModalButtons } from 'components/reusables/modalButtons'
import { RankmiTableWrapper } from './styled'

interface IProps {
  role: IRole
  close: () => void
}

const Detail = ({ role, close }: IProps) => {
  const { t } = useTranslation()
  const prefix =
    'configuration.rolesAndPermissions.roles.table.headers.accessToCourses.courses.detail'
  const [loading, setLoading] = useState(false)
  const [courses, setCourses] = useState<ICourse[]>([])

  useEffect(() => {
    getCourses()
  }, [role.id])

  const getCourses = async () => {
    setLoading(true)
    try {
      const response = await rolesService.getCoursesByRole(role.id)
      const payload = response.data
      setCourses(
        Array.isArray(payload)
          ? payload.map((course) => ({ ...course, key: course.id }))
          : []
      )
    } catch {
      setCourses([])
    } finally {
      setLoading(false)
    }
  }

  const locale = {
    header: {
      rowsCount: t(`${prefix}.table.rowsCount`),
      rowsCount_plural: t(`${prefix}.table.rowsCount_plural`),
    },
  }

  const columns = [
    {
      title: `${t(`${prefix}.table.headers.name`)}`,
      key: 'name',
      render: (name: string) => name,
    },
  ]

  return (
    <Modal
      isOpen={true}
      title={t(`${prefix}.title`)}
      maxwidth={600}
      maxheight={420}
      close={close}
      actions={
        <ModalButtons
          secondaryText={t(`${prefix}.table.actions.close`)}
          secondaryAction={close}
        />
      }
    >
      <RankmiTableWrapper>
        <RankmiTable
          columnHeaders={columns}
          addButtonIcon={faPlus}
          data={courses}
          countIcon={faBook}
          total={courses.length}
          locale={locale}
          loading={loading}
        />
      </RankmiTableWrapper>
    </Modal>
  )
}

export default Detail
